export const locale = {
  lang: 'en',
  data: {
    'HEADER': {
      'TITLE': 'Register details',
    },
  }
};
